module.exports = __webpack_public_path__ + "img/Blazing-Star-Wildflower.6149c4bd.jpg";